import type { ReactNode } from "react";
import { cn } from "@/utils/cn";

export type BadgeTone = "teal" | "gold" | "danger" | "neutral";

const toneClasses: Record<BadgeTone, string> = {
  teal: "bg-teal-500 text-cream-50",
  gold: "bg-gold-100 text-gold-700 border border-gold-300",
  danger: "bg-danger-500 text-cream-50",
  neutral: "bg-cream-200 text-ink-muted border border-border",
};

export function Badge({
  children,
  tone = "neutral",
  className,
}: {
  children: ReactNode;
  tone?: BadgeTone;
  className?: string;
}) {
  return <span className={cn("pill", toneClasses[tone], className)}>{children}</span>;
}
